import { render, staticRenderFns } from "./v-gain-b.vue?vue&type=template&id=34cf1a7e&"
import script from "./v-gain-b.vue?vue&type=script&lang=js&"
export * from "./v-gain-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports